import { HighlightFieldsFragment } from 'api/graphql-types';
import { Tabs } from 'components/tabs';
import { Typography } from 'components/typography';
import { Tab } from './tab';
import { useHighlight } from './use-highlight';
import styles from './highlight.module.scss';

export interface IHighlightProps {
	module: HighlightFieldsFragment;
}

export const Highlight = ({ module }: IHighlightProps): React.JSX.Element => {
	const { title, theme } = module;
	const { tabs } = useHighlight({ module, themeId: theme?.data?.documentId });

	if (!tabs || tabs.length === 0) return <></>;

	return (
		<aside>
			{title?.value && (
				<Typography tag={title.tag || 'h2'} variant="h2" className={styles.title}>
					{title.value}
				</Typography>
			)}

			<Tabs items={tabs}>
				{(activeTab) => {
					if (!activeTab) {
						return <></>;
					}

					const currentTab = tabs.find((item) => item?.__typename === activeTab.type);

					if (currentTab) {
						return (
							<Tab
								items={currentTab?.items || []}
								empty={currentTab.empty}
								buttonHref={currentTab.buttonHref?.url}
								buttonTitle={currentTab.buttonHref?.text}
								theme={{ ...theme?.data?.attributes, id: theme?.data?.documentId }}
								title={currentTab.title}
							/>
						);
					}

					return <></>;
				}}
			</Tabs>
		</aside>
	);
};

export default Highlight;
